import { render } from "./accountReview.vue?vue&type=template&id=2801217e&scoped=true"
import script from "./accountReview.vue?vue&type=script&lang=js"
export * from "./accountReview.vue?vue&type=script&lang=js"

import "./accountReview.vue?vue&type=style&index=0&id=2801217e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2801217e"

export default script